import React from 'react';

import { BasicTimerPropsType } from './Basic';
import TimerBlueCommand from './BlueCommand';
import PauseTimer, { IPauseTimerProps } from './Pause';
import TimerRedCommand from './RedCommand';

export type BasicCommandType = Omit<BasicTimerPropsType, '$inactive_color' | '$active_color'>;

export type TimerProps = Partial<BasicCommandType> & Partial<IPauseTimerProps>;

export const timerTypes = (props: TimerProps) => ({
  red: <TimerRedCommand {...(props as BasicCommandType)} />,
  blue: <TimerBlueCommand {...(props as BasicCommandType)} />,
  pause: <PauseTimer {...(props as IPauseTimerProps)} />,
});
